module.exports = __webpack_public_path__ + "img/malaysia.fb99d491.svg";